//Footer component

import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer p-4 bg-green-600 text-white">
      <div className="w-full max-w-5xl mx-auto px-6 text-center">
        <p className="inline-block mr-4">&copy; {new Date().getFullYear()} PlanX Universe | PSpace</p>
        <nav className="inline-block">
          <Link to="/about-us" className="text-white mx-2 hover:underline">About Us</Link>
          <Link to="/privacy-policy" className="text-white mx-2 hover:underline">Privacy Policy</Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
